import { Component, OnInit, Input } from '@angular/core';
import { Legend } from 'src/app/modules/framework/home-pages/manager-hr-dashboard/models/Legend';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss'],
})
export class LegendComponent implements OnInit {
  constructor() { }

  @Input() legends: Legend[];
  @Input() overviewTitle: string;
  ngOnInit() { }
}
